import {
	defaultPortfolioFilterState,
	type PortfolioFilterState,
} from "web_myplann/Shared/State/portfolioFilterAtom";

export const isPortfolioSortActive = (filter: PortfolioFilterState) =>
	filter.sort !== defaultPortfolioFilterState.sort ||
	filter.sortDesc !== defaultPortfolioFilterState.sortDesc;
